export default __webpack_public_path__ + "static/media/778.c61f763b.png";